/* eslint-disable no-unused-vars */
import React from 'react';
// import SettingsSidebar from '../../core/navigation/settings/Settings';
import LoggedIn from '../logged-in/LoggedIn';
import SettingsHeader from './SettingsHeader/SettingsHeader';

function SettingsLayout({
  heading, children, toolbar, loading, actions, isGlobalSearching,
}) {
  return (
    <LoggedIn
      toolbar={toolbar}
      loading={loading}
    >
      {children}
    </LoggedIn>
  );
}

export default SettingsLayout;
